
import '../App.sass';
import { useState } from "react";
import { v4 as uuidv4 } from 'uuid';

interface Properties {
  className?: string;
  text?: string;
  onUpload?: (files: FileList) => void;
}

export const DocumentSlot = (properties: Properties) => {
  const [forId] = useState(uuidv4());

  const [dragOver, setDragOver] = useState(false);

  const handleDragOver = (e: any) => {
    e.preventDefault();
    setDragOver(true);
  };

  const handleDragLeave = (e: any) => {
    e.preventDefault();
    setDragOver(false);
  };

  const handleDrop = (e: any) => {
    e.preventDefault();

    setDragOver(false);

    console.log(e);

    if (properties.onUpload) {
      properties.onUpload(e.target.files);
    }
  };

  const handleFileChange = (e: any) => {
    if (properties.onUpload) {
      properties.onUpload(e.target.files);
    }
  };

  return <div className="documentSlot">
    <div
      className={`${properties.className || ''} dropZone ${dragOver ? "dragOver" : ""}`}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      <div className='marginTopL displayFlex justifyContentCenter'>
        <input
          style={{ border: 'none' }}
          id={forId}
          multiple
          type="file"
          onChange={handleFileChange}
        >          
        </input>
      </div>
    </div>
  </div>;
};